module.exports = __webpack_public_path__ + "static/media/bts_lalela_170714_030_small.df9055da.jpg";